module.exports = __webpack_public_path__ + "static/img/英文師資介紹.804021ad.png";